import Button from '../button/Button';
import FilterSidebar from './FilterSidebar';
import OptionsPanel from './OptionsPanel';
import { MultiFieldFilterV2Props } from './types';
import useMultiFieldFilter from './useMultiFieldFilter';

const MultiFieldFilterV2 = ({
  fieldOptions,
  onApply,
  selectedFilters,
  buttonClass,
  type = 'multi',
  customFields,
  setCustomFields,
  onClear
}: MultiFieldFilterV2Props) => {
  const {
    isOpen,
    open,
    close,
    activeField,
    selectField,
    selected,
    selectAllModes,
    excludedItems,
    isSelectAllMode,
    isAllSelected,
    totalSelected,
    currentField,
    isSingleSelect,
    hasOptions,
    searchTerms,
    handleSearch,
    dateRange,
    handleDateChange,
    toggleItem,
    toggleSelectAll,
    setFieldSelected,
    handleOptionsScroll,
    handleApply,
    handleClear,
    containerRef,
    optionsScrollRef
  } = useMultiFieldFilter({
    fieldOptions,
    onApply,
    selectedFilters,
    type,
    customFields,
    setCustomFields
  });

  return (
    <div className="relative" ref={containerRef}>
      <div className="relative">
        <Button
          variant="tertiary"
          handleClick={() => (isOpen ? close() : open())}
          size="medium"
          label="Filter"
          className={`ml-auto w-24 justify-between ${buttonClass || ''}`}
          leftIconName="filter"
        />
        {type === 'multi' && totalSelected > 0 && (
          <div className="absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-xl bg-primary text-xs text-theme">
            {totalSelected}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-1 flex w-[520px] flex-col overflow-hidden rounded-2xl bg-white shadow-[0px_4px_7px_0px_rgba(0,0,0,0.1)]">
          <div className="border-b border-cofeeGreyBlue3 px-6 py-3.5">
            <span className="text-lg font-semibold text-content">Filters</span>
          </div>

          <div className="flex h-[300px]">
            <FilterSidebar
              fieldOptions={fieldOptions}
              activeField={activeField}
              selected={selected}
              selectAllModes={selectAllModes}
              excludedItems={excludedItems}
              type={type}
              onSelectField={selectField}
            />
            <OptionsPanel
              currentField={currentField}
              activeField={activeField}
              isSingleSelect={isSingleSelect}
              hasOptions={hasOptions}
              isSelectAllMode={isSelectAllMode}
              isAllSelected={isAllSelected}
              selected={selected}
              excludedItems={excludedItems}
              searchTerms={searchTerms}
              dateRange={dateRange}
              optionsScrollRef={optionsScrollRef}
              onSearch={handleSearch}
              onScroll={handleOptionsScroll}
              onToggleItem={toggleItem}
              onToggleSelectAll={toggleSelectAll}
              onDateChange={handleDateChange}
              onSelectedChange={setFieldSelected}
            />
          </div>

          <div className="flex items-center justify-end gap-4 border-t border-cofeeGreyBlue3 px-6 py-3">
            <Button
              label="Discard"
              variant="tertiary"
              handleClick={() => {
                onClear?.();
                handleClear();
              }}
              className="!h-11 !rounded-lg !border !border-cofeeNeutral4 !px-4"
            />
            <Button
              label="Confirm"
              handleClick={handleApply}
              className="!h-11 !rounded-lg !px-4"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiFieldFilterV2;
